import React from 'react';
import { Trophy, TrendingUp } from 'lucide-react';

const participants = [
  { id: 'plb-1', rank: 1, name: 'Vikram Nair', country: '🇮🇳', score: 2480, accuracy: '94%', badge: 'Grandmaster', badgeClass: 'rank-badge-diamond' },
  { id: 'plb-2', rank: 2, name: 'Sarah Chen', country: '🇸🇬', score: 2340, accuracy: '91%', badge: 'Master', badgeClass: 'rank-badge-platinum' },
  { id: 'plb-3', rank: 3, name: 'Omar Farouq', country: '🇦🇪', score: 2280, accuracy: '89%', badge: 'Diamond', badgeClass: 'rank-badge-diamond' },
  { id: 'plb-4', rank: 4, name: 'Priya Sharma', country: '🇮🇳', score: 2150, accuracy: '86%', badge: 'Gold', badgeClass: 'rank-badge-gold' },
  { id: 'plb-5', rank: 5, name: 'Marcus Williams', country: '🇺🇸', score: 2080, accuracy: '84%', badge: 'Gold', badgeClass: 'rank-badge-gold' },
  { id: 'plb-6', rank: 6, name: 'Yuki Tanaka', country: '🇯🇵', score: 1980, accuracy: '81%', badge: 'Silver', badgeClass: 'rank-badge-silver' },
  { id: 'plb-7', rank: 7, name: 'Fatima Al-Hassan', country: '🇦🇪', score: 1920, accuracy: '79%', badge: 'Silver', badgeClass: 'rank-badge-silver' },
  { id: 'plb-8', rank: 8, name: 'Carlos Rivera', country: '🇲🇽', score: 1860, accuracy: '77%', badge: 'Silver', badgeClass: 'rank-badge-silver' },
];

export default function ParticipantLeaderboard() {
  return (
    <div className="rounded-xl p-5" style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <Trophy size={18} style={{ color: '#F59E0B' }} />
          <h2 className="text-base font-bold text-foreground">Current Leaders</h2>
        </div>
        <span className="text-xs font-semibold px-2 py-1 rounded-lg" style={{ background: 'rgba(16,185,129,0.15)', color: '#10B981' }}>
          Live Standings
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr style={{ borderBottom: '1px solid var(--border)' }}>
              {['Rank', 'Player', 'Country', 'Score', 'Accuracy', 'Tier']?.map((h) => (
                <th key={`plb-th-${h}`} className="text-left pb-3 pr-4"
                  style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'var(--muted-foreground)' }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {participants?.map((p) => (
              <tr key={p?.id} className="border-b hover:bg-muted/30 transition-colors" style={{ borderColor: 'var(--border)' }}>
                <td className="py-3 pr-4">
                  <span className="text-sm font-bold" style={{ color: p?.rank <= 3 ? '#F59E0B' : 'var(--muted-foreground)', fontVariantNumeric: 'tabular-nums' }}>
                    {p?.rank <= 3 ? ['🥇', '🥈', '🥉']?.[p?.rank - 1] : `#${p?.rank}`}
                  </span>
                </td>
                <td className="py-3 pr-4">
                  <span className="text-sm font-semibold text-foreground">{p?.name}</span>
                </td>
                <td className="py-3 pr-4">
                  <span className="text-base">{p?.country}</span>
                </td>
                <td className="py-3 pr-4">
                  <span className="text-sm font-bold" style={{ color: 'var(--foreground)', fontVariantNumeric: 'tabular-nums' }}>
                    {p?.score?.toLocaleString()}
                  </span>
                </td>
                <td className="py-3 pr-4">
                  <div className="flex items-center gap-1">
                    <TrendingUp size={12} style={{ color: '#10B981' }} />
                    <span className="text-sm" style={{ color: '#10B981', fontVariantNumeric: 'tabular-nums' }}>{p?.accuracy}</span>
                  </div>
                </td>
                <td className="py-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${p?.badgeClass}`} style={{ fontSize: '10px' }}>
                    {p?.badge}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs mt-4" style={{ color: 'var(--muted-foreground)' }}>
        Showing top 8 of 2,847 participants. Standings update every 30 seconds during active competition.
      </p>
    </div>
  );
}